"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _messages = _interopRequireDefault(require("../messages"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var data = {
  yesterday: {
    from: (0, _moment["default"])().subtract(1, 'day').startOf('day').toDate(),
    to: (0, _moment["default"])().subtract(1, 'day').endOf('day').toDate()
  },
  week: {
    from: (0, _moment["default"])().subtract(1, 'week').startOf('day').toDate(),
    to: (0, _moment["default"])().subtract(1, 'day').endOf('day').toDate()
  },
  x2week: {
    from: (0, _moment["default"])().subtract(2, 'week').startOf('day').toDate(),
    to: (0, _moment["default"])().subtract(1, 'day').endOf('day').toDate()
  },
  month: {
    from: (0, _moment["default"])().subtract(1, 'month').startOf('day').toDate(),
    to: (0, _moment["default"])().subtract(1, 'day').endOf('day').toDate()
  }
};

var _default = function _default(intl) {
  return Object.keys(data).map(function (key) {
    return _objectSpread(_objectSpread({}, data[key]), {}, {
      label: intl.formatMessage(_messages["default"][key])
    });
  });
};

exports["default"] = _default;